import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Container, Box, Typography, CircularProgress, Button, Paper } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const EmailVerification = () => {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const [status, setStatus] = useState('verifying'); // 'verifying', 'success', 'error'
    const [message, setMessage] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const verify = async () => {
            if (!token) {
                setStatus('error');
                setMessage('Invalid verification link.');
                return;
            }
            try {
                const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/api/verify-email?token=${token}`);
                setStatus('success');
                setMessage(data.message);
            } catch (error) {
                setStatus('error');
                setMessage(error.response?.data?.message || 'Verification failed. The link may be expired or invalid.');
            }
        };
        verify();
    }, [token]);

    return (
        <Container maxWidth="sm">
            <Box sx={{ mt: 10, mb: 10 }}>
                <Paper elevation={3} sx={{ p: 5, textAlign: 'center', borderRadius: 2 }}>
                    {status === 'verifying' && (
                        <Box>
                            <CircularProgress size={60} sx={{ mb: 2, color: '#054A49' }} />
                            <Typography variant="h5" gutterBottom>
                                Verifying your email...
                            </Typography>
                            <Typography color="textSecondary">
                                Please wait while we confirm your account.
                            </Typography>
                        </Box>
                    )}

                    {status === 'success' && (
                        <Box>
                            <CheckCircleOutlineIcon sx={{ fontSize: 80, color: 'success.main', mb: 2 }} />
                            <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', color: '#054A49' }}>
                                Verified!
                            </Typography>
                            <Typography variant="body1" sx={{ mb: 4 }}>
                                {message}
                            </Typography>
                            <Button
                                variant="contained"
                                size="large"
                                onClick={() => navigate('/login')}
                                sx={{ backgroundColor: '#054A49', '&:hover': { backgroundColor: '#043d3c' } }}
                            >
                                Go to Login
                            </Button>
                        </Box>
                    )}

                    {status === 'error' && (
                        <Box>
                            <ErrorOutlineIcon sx={{ fontSize: 80, color: 'error.main', mb: 2 }} />
                            <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', color: 'error.main' }}>
                                Verification Failed
                            </Typography>
                            <Typography variant="body1" sx={{ mb: 4 }}>
                                {message}
                            </Typography>
                            <Button
                                variant="outlined"
                                onClick={() => navigate('/signUp')}
                                sx={{ mr: 2 }}
                            >
                                Back to Sign Up
                            </Button>
                            <Button
                                variant="contained"
                                onClick={() => navigate('/login')}
                                sx={{ backgroundColor: '#054A49' }}
                            >
                                Support
                            </Button>
                        </Box>
                    )}
                </Paper>
            </Box>
        </Container>
    );
};

export default EmailVerification;
